import { Link, useLocation } from 'react-router-dom';
import iustiaLogo from '../../../assets/images/logos/iustia-logo-white.svg';
import { ReactComponent as LoginIcon } from '../../../assets/images/icons/loginicon.svg';
import SideMenu from '../SideMenu';
import { useUI } from '../../../redux/hooks';

const HeaderNavBar = () => {
  const { isSideMenuOpen, openSideMenu, isInHeroSection } = useUI();
  const location = useLocation();
  const isLanding = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 px-8 py-2 ${
        isSideMenuOpen
          ? 'bg-lawyer-bg shadow-xl'
          : isInHeroSection
            ? 'bg-transparent'
            : 'bg-white shadow-xl'
      }`}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center gap-6">
          <Link
            to="/"
            className="flex items-center"
            onClick={e => {
              if (window.location.pathname !== '/') {
                e.preventDefault();
                window.location.href = '/';
              }
            }}
          >
            <img src={iustiaLogo} alt="Iustia Logo" className="h-6 w-auto" />
          </Link>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/login"
            className={`px-1 rounded-full transition-colors ${
              isSideMenuOpen || !isInHeroSection || !isLanding ? 'text-gray-800' : 'text-gray-100'
            }`}
            aria-label="Login"
          >
            <LoginIcon
              className={`h-6 w-auto transition-colors ${
                isSideMenuOpen
                  ? 'stroke-white'
                  : !isInHeroSection || !isLanding
                    ? 'stroke-gray-800'
                    : 'stroke-gray-100'
              }`}
            />
          </Link>
          <button
            onClick={openSideMenu}
            className="flex flex-col justify-center w-12 h-12 bg-transparent border-none cursor-pointer p-0"
            aria-label="Menu"
          >
            <div className="flex flex-col gap-1.5 py-2 px-2">
              <span
                className={`block w-7 h-0.5 transition-all duration-300 rounded-2xl ${
                  isSideMenuOpen
                    ? 'bg-white'
                    : !isInHeroSection || !isLanding
                      ? 'bg-gray-800'
                      : 'bg-gray-100'
                }`}
              ></span>
              <span
                className={`block w-5 h-0.5 transition-all duration-300 rounded-2xl ml-2 ${
                  isSideMenuOpen
                    ? 'bg-white'
                    : !isInHeroSection || !isLanding
                      ? 'bg-gray-800'
                      : 'bg-gray-100'
                }`}
              ></span>
            </div>
          </button>
        </div>
      </div>

      {/* Side Menu */}
      <SideMenu />
    </header>
  );
};

export default HeaderNavBar;
